import { AgentSetting } from './AgentSetting';

export class Agent {
  idAgent: number | null;
  code: string;
  locked: boolean;
  settings: AgentSetting[];

  constructor(
    idAgent: number | null,
    code: string,
    locked: boolean,
    settings: AgentSetting[]
  ) {
    this.idAgent = idAgent;
    this.code = code;
    this.locked = locked;
    this.settings = settings;
  }

  static fromRaw(raw: any): Agent {
    return new Agent(
      raw.idAgent ?? null,
      String(raw.code),
      Boolean(raw.locked),
      Object.values(raw.agentSettings || {}).map(AgentSetting.fromRaw)
    );
  }

  clone(): Agent {
    return new Agent(
      this.idAgent,
      this.code,
      this.locked,
      this.settings.map(setting => setting.clone())
    );
  }

  toPayload(): any {
    const payload: any = {
      code: this.code,
      locked: this.locked,
      settings: this.settings.map(setting => setting.toPayload()),
    };

    if (this.idAgent !== null) {
      payload.idAgent = this.idAgent;
    }

    return payload;
  }

  applySettings(incomingSettings: Partial<AgentSetting>[]): void {
    const existingMap = new Map<number, AgentSetting>();
    for (const setting of this.settings) {
      if (setting.idAgentSetting !== null) {
        existingMap.set(setting.idAgentSetting, setting);
      }
    }

    const newSettings: AgentSetting[] = [];

    for (const raw of incomingSettings) {
      if (raw.idAgentSetting !== null && raw.idAgentSetting !== undefined && existingMap.has(raw.idAgentSetting)) {
        const setting = existingMap.get(raw.idAgentSetting)!;
        if (raw.settingKey !== undefined) setting.settingKey = raw.settingKey;
        if (raw.defaultValue !== undefined) setting.defaultValue = raw.defaultValue;
        newSettings.push(setting);
      } else {
        newSettings.push(
          new AgentSetting(
            null,
            this.idAgent,
            raw.settingKey ?? '',
            raw.defaultValue ?? ''
          )
        );
      }
    }

    this.settings = newSettings;
  }
}
